import { ActionReducer } from '@ngrx/store';

import * as actions from '../actions/';
import {TileState}  from '../state/TileState';

export function listTileReducerFactory<TListModel, TModel>(module: string, listModelType: { new(): TListModel }, modelType: { new(): TModel; }, initialState: TileState<TListModel,TModel>): ActionReducer<TileState<TListModel,TModel>> {
  var func = (state = initialState, action: actions.Actions<TModel|TListModel>): TileState<TListModel, TModel> => {
    switch (action.type) {
      case actions.getQueryListType(module, listModelType):
        const queryAction = (action as actions.QueryListAction<TListModel>);
        return {
          ...state,
          loading: true,
          currentPage: queryAction.payload.page,
          list: [],
          errors: []
        };
      case actions.querySuccessType(module, listModelType):
        const querySuccessAction = (action as actions.QuerySuccessAction<TListModel>);
        return {
          ...state,
          list: querySuccessAction.payload.items,
          totalCount: querySuccessAction.payload.totalCount,
          loading: false
        };
      case actions.getSelectionType(module, modelType):
        return {
          ...state,
          loading: true,
          selected: null,
          errors: []
        };
      case actions.getClearSelectionType(module, modelType):
        return {
          ...state,
          selected: null
        };
      case actions.getSelectionSuccessType(module, modelType):
        const selectionSuccessAction = (action as actions.GetSelectionSuccessAction<TModel>);
        return {
          ...state,
          loading: false,
          selected: selectionSuccessAction.payload.model
        };
      case actions.getTileErrorsType(module, modelType):
      case actions.getTileErrorsType(module, listModelType):
        const tileErrorsAction = (action as actions.TileErrorsAction<TModel>);
        return {
          ...state,
          loading: false,
          errors: state.errors.concat(tileErrorsAction.payload.errors)
        };
      case actions.getClearErrorsType(module, modelType):
      case actions.getClearErrorsType(module, listModelType):
        return {
          ...state,
          errors: []
        };
      case actions.getStopLoadingType(module, modelType):
      case actions.getStopLoadingType(module, listModelType):
        return {
          ...state,
          loading: false
        };
      default:
        return state;
    }
  };
  return func;
}



// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/store/reducers/list-tile.reducerFactory.ts